var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 57,
    viewBox: "0 0 130 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.0109 0L130 20.1596L61.8663 51.7371L0 18.7324L66.0109 0Z",
    fill: "#4777A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8663 51.7371L130 20.1596L129.393 24.4413L61.8663 57V51.7371Z",
    fill: "#5DA3E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8663 51.7371L0 18.7324L0.606532 23.0141L61.8663 57V51.7371Z",
    fill: "#074684"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home2.0118c9b97716c8f53cbfdcbcfd4bfab6.svg";
export { ForwardRef as ReactComponent };